import styled, { css } from 'styled-components';
import { FavoriteHollowIcon, FavoriteIcon, MinusIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
const ratingTypesTemplate = {
  STAR_RATING: {
    checkedColor: 'fill-accent-yellow-default',
    uncheckedColor: 'icon-primary-disabled',
    checkedIcon: FavoriteIcon,
    uncheckedIcon: FavoriteHollowIcon
  },
  STAR_RATING_DISABLED: {
    checkedColor: 'fill-tertiary-pressed',
    uncheckedColor: 'border-core-subtle',
    checkedIcon: FavoriteIcon,
    uncheckedIcon: FavoriteHollowIcon
  },
  STAR_RATING_FILLED: {
    checkedColor: 'fill-accent-yellow-default',
    uncheckedColor: 'border-core-subtle',
    checkedIcon: FavoriteIcon,
    uncheckedIcon: FavoriteIcon
  },
  STAR_RATING_EMPTY_STATE: {
    checkedColor: 'border-core-subtle',
    uncheckedColor: 'border-core-subtle',
    checkedIcon: FavoriteIcon,
    uncheckedIcon: FavoriteIcon
  },
  PILL_RATING: {
    checkedColor: 'icon-tertiary-default',
    uncheckedColor: 'border-core-subtle',
    checkedIcon: MinusIcon,
    uncheckedIcon: MinusIcon
  }
};
const backgroundPillStyles = css(["width:30px;background-color:", ";border:2px solid ", ";border-radius:", ";"], ({
  checked,
  disabled,
  theme
}) => {
  if (checked) {
    return theme.color['fill-accent-neutral-hover'];
  } else if (disabled) {
    return theme.color['fill-tertiary-default'];
  }
  return theme.color['fill-surface-default'];
}, ({
  checked,
  theme
}) => checked ? theme.color['fill-accent-neutral-hover'] : theme.color['fill-tertiary-default'], ({
  index
}) => {
  if (index === 1) {
    return '8px 0 0 8px';
  } else if (index === 5) {
    return '0 8px 8px 0';
  }
  return 0;
});
const foregroundPillStyles = css(["left:0;position:absolute;z-index:1;background-color:", ";width:", ";"], ({
  disabled,
  theme
}) => disabled ? theme.color['fill-tertiary-pressed'] : theme.color['fill-accent-neutral-hover'], ({
  percentFilled
}) => `${percentFilled * 30 / 100}px`);
export const PillIcon = styled.div.withConfig({
  displayName: "AbstractRatingIcons__PillIcon",
  componentId: "nir704-0"
})(["height:15px;margin:1px;border-radius:", ";", ";"], ({
  index,
  percentFilled
}) => {
  let borderRadius = '0';
  if (index === 1) {
    borderRadius = '8px 0 0 8px';
  } else if (index === 5) {
    borderRadius = '0 8px 8px 0';
  }
  return !(percentFilled < 100 && index === 5) && borderRadius;
}, ({
  isForeground
}) => isForeground ? foregroundPillStyles : backgroundPillStyles);
const foregroundStarStyles = css(["left:0;overflow:hidden;position:absolute;z-index:1;width:", ";"], ({
  percentFilled
}) => `${percentFilled / 100}em`);
export const starRatingFactory = type => props => {
  const {
    isForeground,
    checked,
    size
  } = props;
  const IconComponent = ratingTypesTemplate[type][`${isForeground ? 'checkedIcon' : 'uncheckedIcon'}`];
  return /*#__PURE__*/_jsx(IconComponent, {
    color: ratingTypesTemplate[type][`${isForeground || checked ? 'checkedColor' : 'uncheckedColor'}`],
    size: size
  });
};
const sharedStarStyles = 'line-height: 117%; margin-right: 0 !important;';
export const StarRating = styled(starRatingFactory('STAR_RATING')).withConfig({
  displayName: "AbstractRatingIcons__StarRating",
  componentId: "nir704-1"
})(["", " ", ";"], sharedStarStyles, ({
  isForeground
}) => isForeground ? foregroundStarStyles : '');
export const StarRatingDisabled = styled(starRatingFactory('STAR_RATING_DISABLED')).withConfig({
  displayName: "AbstractRatingIcons__StarRatingDisabled",
  componentId: "nir704-2"
})(["", " ", ";"], sharedStarStyles, ({
  isForeground
}) => isForeground ? foregroundStarStyles : '');
export const StarRatingFilled = styled(starRatingFactory('STAR_RATING_FILLED')).withConfig({
  displayName: "AbstractRatingIcons__StarRatingFilled",
  componentId: "nir704-3"
})(["", " ", ";"], sharedStarStyles, ({
  isForeground
}) => isForeground ? foregroundStarStyles : '');
export const StarRatingEmpty = styled(starRatingFactory('STAR_RATING_EMPTY_STATE')).withConfig({
  displayName: "AbstractRatingIcons__StarRatingEmpty",
  componentId: "nir704-4"
})(["", " ", ";"], sharedStarStyles, ({
  isForeground
}) => isForeground ? foregroundStarStyles : '');